<template>
  <div class="serviceSiteInfo">
    <div class="clear">
      <h2 class="paging-title">服务站认证</h2>
      <template v-if="showMsg">
        <div class="audit-tips" v-if="info.EditApplyStatus == 2 || (info.EditApplyStatus == 0 && info.ApplyStatus == 2)">
          <span>您的认证信息已成功提交，正在审核中…</span>
          <i class="icon-close" @click="removeMsg">×</i>
        </div>
        <div class="audit-tips" v-else-if="info.ApplyStatus == 5 && info.EditApplyStatus == 0">
          <span>您的认证信息未审核通过，请您修改信息之后，再进行重新提交审核</span>
          <span class="btn-link" @click="toEdit">去编辑</span>
          <i class="icon-close" @click="removeMsg">×</i>
        </div>
        <div class="audit-tips" v-else-if="info.EditApplyStatus == 5">
          <span>您的认证信息未审核通过，请您修改信息之后，再进行重新提交审核</span>
          <span class="btn-link" @click="toEdit">去编辑</span>
          <i class="icon-close" @click="removeMsg">×</i>
        </div>
        <span v-else class="link-edit" @click="toEdit">去编辑</span>
        <!-- <a v-else href="/Member/ApplyCompanyService/BusinessServicesEdit" class="link-edit" style="">编辑</a> -->
      </template>
    </div>
    <div class="form">
      <div class="form-item">
        <label class="label"><i class="required">*</i>团队规模：</label>
        <div class="input-box">
          <span class="value">{{info.TeamPeopleCount}}</span>
        </div>
      </div>
      <div class="form-item">
        <label class="label"><i class="required">*</i>公司介绍：</label>
        <div class="input-box">
          <span class="value">{{info.CompanySummary}}</span>
        </div>
      </div>
      <div class="form-item">
        <label class="label"><i class="required">*</i>纳税属性：</label>
        <div class="input-box">
          <span class="icon-radio"></span>
          <span class="value">{{info.EnterPrisePropertyName}}</span>
        </div>
      </div>
      <div class="form-item half">
        <label class="label"><i class="required">*</i>业务联系人：</label>
        <div class="input-box">
          <span class="value">{{info.LinkMan}}</span>
        </div>
      </div>
      <div class="form-item half">
        <label class="label"><i class="required">*</i>联系电话：</label>
        <div class="input-box">
          <span class="value">{{info.HandSet}}</span>
        </div>
      </div>
      <div class="form-item half">
        <label class="label"><i class="required">*</i>技术负责人：</label>
        <div class="input-box">
          <span class="value">{{info.TechnologyLinkMan}}</span>
        </div>
      </div>
      <div class="form-item half">
        <label class="label"><i class="required">*</i>联系电话：</label>
        <div class="input-box">
          <span class="value">{{info.TechnologyHandset}}</span>
        </div>
      </div>
      <div class="form-item">
        <label class="label"><i class="required">*</i>办公地址：</label>
        <div class="input-box">
          <span class="value">{{info.FullAddress}}{{info.Address}}</span>
        </div>
      </div>
      <div class="form-item half">
        <label class="label">公司负责人：</label>
        <div class="input-box">
          <span class="value">{{info.DutyLinkMan}}</span>
        </div>
      </div>
      <div class="form-item half">
        <label class="label">联系电话：</label>
        <div class="input-box">
          <span class="value">{{info.DutyHandSet}}</span>
        </div>
      </div>
      <div class="form-item half">
        <label class="label">母公司：</label>
        <div class="input-box">
          <span class="value">{{info.ParentCompanyName}}</span>
        </div>
      </div>
      <div class="form-item half">
        <label class="label">年营业额：</label>
        <div class="input-box">
          <span class="value">{{info.YearlyTurnover}}万元</span>
        </div>
      </div>
      <div class="form-item">
        <label class="label"><i class="required">*</i>服务类型认证：</label>
        <div class="input-box">
          <div class="tag-item" v-for="(item,index) in stagesAuth" :key="item.ServiceStageId+''+index">
            {{item.DomainName}}-
            {{item.ServiceStageName}}
          </div>
        </div>
      </div>
      <div class="form-item">
        <label class="label"><i class="required">*</i>产品品牌认证：</label>
      </div>
      <div class="form-item" v-for="(domain) in brandTagList" :key="domain.DomainID">
        <label class="label">{{domain.DomainName}}</label>
        <div class="input-box">
          <div class="tag-item" v-for="(item,i) in domain.ProductList" :key="i">
            {{item.auth}}
          </div>
        </div>
      </div>
      <div class="form-item">
        <label class="label"><i class="required">*</i>擅长行业：</label>
        <div class="input-box">
          <span class="block-item" v-for="(item,index) in info.ComIndustryList" :key="index">{{item.IndustryName}}</span>
        </div>
      </div>
      <div class="form-item">
        <label class="label"><i class="required">*</i>期望服务城市：</label>
        <div class="input-box">
          <span class="block-item" v-for="(item,index) in info.ExpectCityList" :key="index">{{item.ProvinceName+'·'+item.CityName}}</span>
        </div>
      </div>
      <div class="form-item">
        <label class="label">资质证书：</label>
        <div class="input-box">
          <div class="cert-item" v-for="(item,index) in info.ComAccountCertList" :key="index">
            <div class="cert-name">
              {{item.Name}}
            </div>
            <ul class="cert-pics">
              <li v-if="item.CertificateURL">
                <img class="pic" :src="item.CertificateURL" alt="" preview="1" preview-text="证书正面">
              </li>
              <li v-if="item.CertificateURL2">
                <img class="pic" :src="item.CertificateURL2" alt="" preview="1" preview-text="证书反面">
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="form-item">
        <label class="label"><i class="required">*</i>项目经历：</label>
        <div class="input-box">
          <ul class="project-list">
            <li class="project-item" v-for="(item,index) in info.SuccessfulCaseList" :key="index">
              <div class="flex">
                <div class="name">{{item.ProjectName}}</div>
                <span class="time">{{item.ProjectYear}}</span>
              </div>
              <div class="flex">
                <div class="project-info">
                  <span class="project-label">行业：</span>
                  <span class="project-value">{{item.IndustryName}}</span>
                </div>
                <div class="project-info">
                  <span class="project-label">服务类型：</span>
                  <span class="project-value">{{item.ServiceTypeName}}</span>
                </div>
                <div class="project-info">
                  <span class="project-label">项目描述：</span>
                  <span class="project-value">{{item.ServiceDesc}}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="form-item">
        <label class="label">我的工程师：</label>
        <div class="input-box">
          <table class="table">
            <tr>
              <th>工程师姓名</th>
              <th>手机号</th>
            </tr>
            <tr v-for="(item,index) in info.ComUserEngineerList" :key="index">
              <td>{{item.TrueName}}</td>
              <td>{{item.Handset}}</td>
            </tr>
          </table>
        </div>
      </div> 
      
    </div>
  </div>
</template>
<script>
import {p_origin} from '@/scripts/util.js'
import {mapState} from 'vuex'
import _ from 'lodash'
import { 
  GetServiceSiteAuthInfo,
} from '@/scripts/api.js'
export default {
  name:'serviceSiteInfo',
  data(){
    return{
      homeUrl:p_origin,
      companyId:'',
      info:{},
      showMsg:true,
      stagesAuth:[],
      brandTagList:[],
    }
  },
  computed: {
    ...mapState({
      userInfo:state=>state.userInfo,
    })
  },
  watch: {
    userInfo:{
      handler(value){
        if(value && value.LoginAccountId){
          this.companyId=value.LoginAccountId;
          this.getEditInfo();
        }
      },
      deep:true,
      immediate:true,
    }
  },
  created(){
    this.getEditInfo();
  },
  methods: {
    //获取服务站信息
    getEditInfo(){
      GetServiceSiteAuthInfo({
        CompanyId:this.companyId,
        platform:'pcweb'
      }).then(r=>{
        if(r.Result==1){
          let data={
            ...r.Data
          }
          this.info=data;
          this.stagesAuth=data.ServiceStageTagList||[];
          let list=data.ProductBrandTagList||[];
          var arr=[];
          for (let i = 0; i < list.length; i++) {
            //根据产品id分组，返回一个对象
            let product=_.groupBy(list[i].ProductTagList,'ProductId');
            let productArr=[];
            for (const k in product) {
              //对象的属性是不同产品的ID，
              let obj={
                ...list[i],
                Id:Number(k),
                brands:product[k],
              }
              var brandNameArr=_.map(product[k],item=>{
                return item.BrandName
              });
              if(brandNameArr.length){
                obj['auth']=product[k][0].ProductName+'-'+brandNameArr.join('/');
                obj['ProductCategoryName']=product[k][0].ProductName;
              }
              productArr.push(obj);
              list[i]['ProductList']=productArr;
            }
          }
          this.brandTagList=list;
          this.$store.commit('setServiceInfo',data);
          this.$nextTick(()=>{
            this.$previewRefresh(); //图片必须预览刷新才可以点击放大 
          })
        }
      })
    },
    toEdit(){
      // window.location.href="/bpojob/companyCenter.html#/serviceCertificate"
      this.$router.push('/serviceCertificate');
    },
    removeMsg(){
      this.showMsg=false;
    }
  },
}
</script>
<style lang="scss">
.serviceSiteInfo{
  .paging-title{
    font-size: 18px;
    line-height: 24px;
    color: #f75959;
    margin-bottom: 20px;
    &:before{
      content:'';
      display: inline-block;
      width: 2px;
      height: 20px;
      background-color: #f75959;
      vertical-align: middle;
      margin-top: -3px;
      margin-right: 16px;
    }
  }
  .link-edit{
    font-size: 12px;
    color: #f75959;
    line-height: 24px;
    float: right;
    padding: 0 10px;
    background-color: #f8f8f8;
    float: right;
    border-radius: 2px;
  }
  .audit-tips{
    font-size: 14px;
    color: #f75959;
    line-height: 24px;
    float: right;
    .icon-close{
      display: inline-block;
      font-size: 20px;
      cursor: pointer;
      margin-left: 10px;
      vertical-align: middle;
      margin-top: -3px;
    }
    .btn-link{
      text-decoration: underline;
      color: #f75959;
      padding-left: 6px;
    }
  }
  .form{
    background-color: #F9F9F9;
    padding-top: 34px;
    padding-bottom: 45px;
    padding-left: 10px;
    overflow: hidden;
  }
  .form-item{
    margin-bottom: 20px;
    float: left;
    width: 100%;
    &.half{
      width: 50%;
    }
    &:after{
      content: "";
      display: block;
      clear: both;
    }
    .value{
      display: inline-block;
      word-break: break-all;
      margin-right: 20px;
      font-size: 14px;
      color: #666;
      line-height: 38px;
    }
  }
  .label{
    float: left;
    min-width: 100px;
    height: 38px;
    margin-right: 20px;
    font-size: 14px;
    color: #666;
    line-height: 38px;
  }
  .input-box{
    float: left;
    min-width: 360px;
    position: relative;
  }
  .tag-item{
    width: 500px;
    min-height: 38px;
    border: 1px solid #e7e7e7;
    padding: 8px 40px;
    background-color: #fff;
    text-align: center;
    font-size: 14px;
    color: #333;
    line-height: 22px;
    margin-bottom: 10px;
    word-break: break-all;
    position: relative;
  }
  .block-item{
    display: inline-block;
    padding: 0 15px;
    height: 38px;
    margin-right: 10px;
    background-color: #fff;
    color: #666;
    line-height: 38px;
    border-radius: 2px;
  }
  
  .cert-item{
    padding:15px 10px 10px;
    background-color: #fff;
    margin-bottom: 10px;
    margin-right: 10px;
    display: inline-block;
    .cert-name{
      position: relative;
      font-size: 14px;
      color: #333;
      line-height: 24px;
      padding-right: 50px;
    }
    .cert-pics{
      overflow: hidden;
      white-space: nowrap;
      margin-top: 15px;
      >li{
        display: inline-block;
        width: 234px;
        height: 150px;
        &:nth-child(even){
          margin-left: 10px;
        }
      }
      .pic{
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
  .project-list{
    background-color: #fff;
    margin-bottom: -1px;
    width: 680px;
    padding: 0 10px;
    background-color: #fff;
    border: 1px solid #e5e5e5;
    .project-item{
      padding: 10px 0;
      border-bottom: 1px solid #e5e5e5;
      &:last-child{
        border-bottom: 0;
      }
    }
    .flex{
      overflow: hidden;
      margin-bottom: 6px;
      &:nth-child(2){
        padding-right: 50px;
        position: relative;
      }
    }
    .name{
      float: left;
      font-size: 16px;
      color: #333;
      line-height: 24px;
      font-weight: bold;
    }
    .time{
      float: right;
      font-size: 14px;
      color: #333;
      line-height: 24px;
    }
    .project-info{
      font-size: 14px;
      color: #333;
      line-height: 24px;
      float: left;
      margin-right: 50px;
      white-space: nowrap;
      .project-label{
        display: inline-block;
        vertical-align: top;
      }
      .project-value{
        display: inline-block;
        vertical-align: top;
        white-space: normal;
        word-break: break-all;
      }
    }
  }
  .table{
    border-collapse: collapse;
    text-align: center;
    width: 680px;
    background-color: #fff;
    margin-bottom: -1px;
    th{
      height: 48px;
      font-size: 14px;
      color: #333;
      line-height: 48px;
      border: 1px solid #e5e5e5;
      font-weight: bold;
    }
    td{
      height: 48px;
      font-size: 14px;
      color: #333;
      line-height: 48px;
      border: 1px solid #e5e5e5;
    }
  }
}
</style>